import type { TourProgressAdapter } from '@nucleus-commerce/admin-kit/tour';
import {
  deleteAdminV1MeTours,
  getAdminV1MeTours,
  putAdminV1MeToursTourId,
} from '@nucleus-commerce/api-client/admin';

/** `GET/PUT/DELETE /admin/v1/me/tours`: one person's tour progress, the same in every organisation. */
export const adminTourProgress: TourProgressAdapter = {
  list: () => getAdminV1MeTours(),
  save: (tourId, body) => putAdminV1MeToursTourId({ tourId }, body),
  reset: async (tourId) => {
    await deleteAdminV1MeTours(tourId ? { tourId } : undefined);
  },
};
